<template>
  <!--在线签到系统   登录-->
  <div>
    <div class="content">
      <div class="banner">
        <img :src="getBanner" alt="banner" />
      </div>
      <div class="bigTitle">
        <h2>在线签到系统</h2>
        <p>Personal Register</p>
      </div>
      <div class="zhan"></div>

      <router-view />

      <div class="footer">
        <img :src="getFooter" alt="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Banner from "@/assets/img/banner.png";
import Footer from "@/assets/img/footer.png";

export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      config: "signStore/getConfig",
    }),
    getBanner() {
      return this.config.banner || Banner;
    },
    getFooter() {
      return this.config.footer || Footer;
    },
  },
};
</script>

<style></style>
